import React from "react";

import { Table, TableId } from "@greeter/core";
import { TimeOfDay } from "@greeter/date";
import { classNames, entries } from "@greeter/util";
import css from "./BookingListItemHeader.module.scss";

export type BookingListItemHeaderProps = {
  toggled: boolean;
  tables: Map<string, Table[]>;
  partySize: string;
  arrivalTime: TimeOfDay;
  tablePrefixClassName?: string;
  groupSizePrefixClassName?: string;
};

export const BookingListItemHeader: React.FC<BookingListItemHeaderProps> = ({
  toggled,
  tables,
  partySize,
  arrivalTime,
  tablePrefixClassName,
  groupSizePrefixClassName,
}) => {
  return (
    <div className={css.BookingListItemHeader}>
      <div />
      <p {...classNames(css.TextLeft)}>
        {entries(tables).map(([area, tables]) => {
          return (
            <div
              key={`booking-item-header-${area}-${tables
                .map((t) => t.number + "")
                .join(",")}`}
              className={css.TableText}
            >
              <span className={tablePrefixClassName}>
                Bord{tables.length > 1 ? "e" : ""}:{" "}
              </span>
              {tables.map((t) => `${t.number}`).join(", ")}
            </div>
          );
        })}
      </p>
      <p {...classNames(css.TextLeft)}>
        <span className={groupSizePrefixClassName}>Pers.</span> {partySize}
      </p>
    </div>
  );
};
